import React from "react";
// import useFormStore from "../../store/formData";

const TextInput = (props) => {
  return (
    <div className="flex flex-col justify-start w-full gap-2">
      <div
        className={`relative w-full flex items-center border ${props.validation ? "border-[#FF0031]" : "border-[#B0B0B0]"} px-3 py-2 rounded-lg gap-3 ${props.size === "lg" ? "h-12" : "h-10"}`}
      >
        {props.icon && (
          <i
            className={`${props.icon} ${props.size === "sm" ? "text-base" : props.size === "lg" ? "text-2xl" : "text-lg"} ${props.disabled ? "text-[#D1D1D1]" : props.validation ? "text-[#FF0031]" : "text-[#3D3D3D]"}`}
          />
        )}
        {props.icon && (
          <div
            className={`h-5 w-px ${props.disabled ? "bg-[#D1D1D1]" : props.validation ? "bg-[#FF0031]" : "bg-[#3D3D3D]"}`}
          ></div>
        )}
        <input
          className={`outline-none bg-transparent ${props.disabled ? "text-[#D1D1D1] placeholder:text-[#B0B0B0]" : "text-[#3D3D3D] placeholder:text-text-2"} ${props.size === "sm" ? "text-xs" : props.size === "lg" ? "text-base" : "text-md"} w-full pr-1`}
          placeholder={props.placeholder}
          onChange={(e) => {
            props.onChange(e);
          }}
          value={props.value}
          disabled={props.disabled}
          type={props.type ? props.type : "text"}
        />
        {props.label && (
          <span
            className={`${props.size === "sm" ? "text-xs" : "text-sm"} ${props.disabled ? "text-[#D1D1D1]" : props.validation ? "text-[#FF0031]" : "text-[#3D3D3D]"} bg-[#fbfbfb] w-max absolute -top-[10px] right-[10px] px-[6px]`}
          >
            {props.label}
          </span>
        )}
      </div>
      {props.validation && (
        <span className="text-[#FF0031] px-1 text-sm">{props.validation}</span>
      )}
    </div>
  );
};

export default TextInput;
